var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.00651042 0.891917C0.00651042 0.523727 0.304987 0.22525 0.673177 0.22525H11.3333C11.7015 0.22525 12 0.523727 12 0.891917V8.4414C12 9.17777 11.403 9.77473 10.6667 9.77473H1.33333C0.596954 9.77473 0 9.17777 0 8.4414V1.10806C0 1.07632 0.00221904 1.04509 0.00651042 1.01452V0.891917ZM1.33333 2.37442V8.4414H10.6667V2.37465L7.41433 5.62699C6.63328 6.40803 5.36695 6.40804 4.5859 5.62699L1.33333 2.37442ZM2.38155 1.53702H9.61868L6.47152 4.68418C6.21117 4.94453 5.78906 4.94453 5.52871 4.68418L2.38155 1.53702Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.ad4e3811228b0c6645a0d2207a7fbf6d.svg";
export { ForwardRef as ReactComponent };